import styled from 'styled-components/macro';
import React, {
  Suspense,
} from 'react';
import PropTypes from 'prop-types';
import Stack from '../primitives/Stack';
import Grid from '../primitives/Grid';
import Cluster from '../primitives/Cluster';
import Switcher from '../primitives/Switcher';
import Box from '../primitives/Box';
import Markdown from '../Markdown';
import {
  theme,
} from '../../utilsClient/cssHelpers';

// TODO: Add back support for icons and images

// {icon && (
//   <StyledIcon>
//     <img
//       // eslint-disable-next-line global-require, import/no-dynamic-require
//       src={require(`../../../common/assets/icons/${icon}.svg`)}
//       alt={icon}
//     />
//   </StyledIcon>
// )}

// {!!imageUrl && (
//   <PosedContainer>
//     <StyledImg
//       src={imageUrl}
//       alt={prefix}
//     />
//   </PosedContainer>
// )}

const StyledBox = styled(Box.Primary)`
  ${props => props.isFullHeight &&
    `
    overflow-y: auto;
  `};
`;

const StyledStack = styled(Stack)`
  /* TODO: Do we still need it?  */
  ol,
  ul,
  dl {
    padding-left: ${theme('space.3')};
  }
`;

const CardQuestionLayout = ({
  // eslint-disable-next-line react/prop-types
  extra,
  // eslint-disable-next-line react/prop-types
  children,
}) => {
  return (
    <Suspense fallback={<div>loading...</div>}>
      {extra ? (
        <Grid
          space={0}
          align="flex-start"
        >
          {children}
        </Grid>
      ) : (
        children
      )}
    </Suspense>
  );
};

CardQuestionLayout.propTypes = {
  extra: PropTypes.node,
  children: PropTypes.node,
};

CardQuestionLayout.defaultProps = {
  extra: null,
  children: null,
};

const CardQuestion = ({
  title,
  description,
  extra,
  children,
  isFullHeight,
}) => {
  return (
    <StyledBox
      boxShadow="base"
      isFullHeight={isFullHeight}
    >
      <CardQuestionLayout extra={extra}>
        <Stack isFullHeight={isFullHeight}>
          <StyledStack space={0}>
            {title && <Markdown source={`## ${title}`} />}
            {description && (
            <Markdown
              source={description}
              importance="low"
            />
            )}
          </StyledStack>
          <Switcher
            align="center"
            isFullHeight={isFullHeight}
          >
            {extra && <Cluster justify="center">{extra}</Cluster>}
            {children}
          </Switcher>
        </Stack>
      </CardQuestionLayout>
    </StyledBox>
  );
};

CardQuestion.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  extra: PropTypes.node,
  isFullHeight: PropTypes.bool,
};

CardQuestion.defaultProps = {
  title: null,
  description: null,
  extra: null,
  isFullHeight: false,
};

export default CardQuestion;
